import { readFromEnv, Env } from '@cinch-nx/environments'
import axios from 'axios'
import { datadogRum } from '@datadog/browser-rum'

const awinServiceClient = axios.create({
  baseURL: readFromEnv(Env.AwinServiceUrl),
  validateStatus: () => true,
})

export const sendConfirmation = async (
  request: SendAwinConfirmationRequest,
  vehicleVin?: string,
) => {
  try {
    const { status, data } = await awinServiceClient.post('/', request)

    if (status === 200) {
      datadogRum.addAction(
        'Cinch Servicing: Send AWIN Confirmation - Success',
        {
          cinchServicing: true,
          bookingRef: request.orderId,
          statusCode: status,
          ...(vehicleVin ? { vin: vehicleVin } : {}),
        },
      )

      return true
    } else {
      datadogRum.addError(
        new Error('Cinch Servicing: Send AWIN Confirmation - Failure'),
        {
          cinchServicing: true,
          bookingRef: request.orderId,
          statusCode: status,
          ...(vehicleVin ? { vin: vehicleVin } : {}),
          ...(status === 400 ? { validationFailure: data } : {}),
        },
      )
    }

    return false
  } catch (error) {
    datadogRum.addError(
      new Error('Cinch Servicing: Send AWIN Confirmation - Error'),
      {
        cinchServicing: true,
        bookingRef: request.orderId,
        error: error,
        ...(vehicleVin ? { vin: vehicleVin } : {}),
      },
    )
    return false
  }
}

export type SendAwinConfirmationRequest = {
  orderId: string
  orderTotalInPence: number
  userId: string
  clickId: string
  channel: string
  commissionGroup: string
  voucherCode?: string
  testMode?: boolean
  platformType?: 'app' | 'web'
}
